<template>
  <div>
    <div v-if="this.milestoneDetailsRowData.ProductInstanceID" class="popupContent">
      <div class="popup-header">{{ this.milestoneDetailsRowData.OrderRequestName }}</div>
      <TimeLine
        :ProductInstanceID="milestoneDetailsRowData.ProductInstanceID"
      ></TimeLine>
    </div>
    <div v-else>
     <h4> Service Tickets Actions Place Holder </h4>
    </div>
  </div>
</template>

<script>
import TimeLine from "./milestoneTimeline";

export default {
  name: "MilestoneDetailsPopup",
  components: {
    TimeLine,
  },
  props: {
    milestoneDetailsRowData: {
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted: function() {
  }
};
</script>

<style lang="scss" scoped>
.popupContent {
  min-height: 500px;
  padding: 10px;
}
.popup-header {
  font-family: "Lato", sans-serif;
  font-weight: bold;
  color: #006ca5;
  font-size: 16px;
}
</style>